import { requiredMessage, firstOrLastName, pleaseEnterTheMessage } from "../utils/common";
var arhiFieldName = "first name";
var internationalFieldName = "given name";
var iapFieldName = "student's first name";
var VARIANTS = {
  ARHI: arhiFieldName,
  IMAN: internationalFieldName,
  IWHI: internationalFieldName,
  ISHI: internationalFieldName,
  IAP: iapFieldName
};
var VARIANT_REQUIRED_FUNCTION = {
  ARHI: requiredMessage,
  IAP: pleaseEnterTheMessage
};
var validFirstName = function validFirstName(value) {
  var funnel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ARHI";
  var fieldName = arguments.length > 2 ? arguments[2] : undefined;
  var error; // eslint-disable-line init-declarations
  var derivedFieldName = fieldName || VARIANTS[funnel] || VARIANTS.ARHI;
  if (!value) {
    var requiredFunction = VARIANT_REQUIRED_FUNCTION[funnel] || VARIANT_REQUIRED_FUNCTION.ARHI;
    error = requiredFunction(derivedFieldName);
  } else if (firstOrLastName(value)) {
    error = "Only letters, spaces and the following special characters may be used: \u2018 -";
  }
  return error;
};
export default validFirstName;